(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './array', './collection', './lang', './math', './object', './seq', './string', './util'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./array'), require('./collection'), require('./lang'), require('./math'), require('./object'), require('./seq'), require('./string'), require('./util'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.array, global.collection, global.lang, global.math, global.object, global.seq, global.string, global.util);
    global.index = mod.exports;
  }
})(this, function (exports, _array, _collection, _lang, _math, _object, _seq, _string, _util) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.keys(_array).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _array[key];
      }
    });
  });
  Object.keys(_collection).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _collection[key];
      }
    });
  });
  Object.keys(_lang).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _lang[key];
      }
    });
  });
  Object.keys(_math).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _math[key];
      }
    });
  });
  Object.keys(_object).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _object[key];
      }
    });
  });
  Object.keys(_seq).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _seq[key];
      }
    });
  });
  Object.keys(_string).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _string[key];
      }
    });
  });
  Object.keys(_util).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _util[key];
      }
    });
  });
});